import * as R from "ramda";
import { DIMOBS_PARAM } from "./constants/params.mjs";
import { parseDataParams } from "./parseDataParams.mjs";
import { setParam } from "./utils.mjs";
const getDataParams = (args) => R.pipe(
  R.propOr({}, "params"),
  R.pickBy(R.pipe(R.isNil, R.not)),
  parseDataParams,
  R.when(
    R.always(!R.propOr(false, "agnostic")(args)),
    setParam(DIMOBS_PARAM)
  )
)(args);
export {
  getDataParams
};
